export function verif(rows, month, AN) {
  const moisTextuel = ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"];
  const moisStr = moisTextuel[month - 1];
  const anStr = AN.toString().slice(-2);
  const formeDate = `${moisStr}-${anStr}`; 

  var array = [];
  var colCodeGrossiste = 0;
  var colCode = 0;
  var colCmd = 0;
  var colGrossiste = 0;
  var head = false;
  var test = false;

  for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
    const row = rows[rowIndex];
    const lowercaseRow = row.map(val => val.toString().toLowerCase());

   
    if (!head && lowercaseRow.includes("cmd vf") && lowercaseRow.includes("code") && lowercaseRow.includes("code_grossiste") && lowercaseRow.includes("grossiste")) {
      colCode = lowercaseRow.indexOf("code");
      colCmd = lowercaseRow.indexOf("cmd vf");
      colCodeGrossiste = lowercaseRow.indexOf("code_grossiste");
      colGrossiste = lowercaseRow.indexOf("grossiste");
      head = true;
      test = true;
      continue;
    }

    if (!head) continue;

    const code = row[colCode];
    const code_grossiste = row[colCodeGrossiste];
    const grossiste = row[colGrossiste];

    if (
      (typeof code === 'string' ) ||
      (typeof code === 'number' && !isNaN(code))
    ) {
      array.push({
        code_grossiste: code_grossiste,
        grossiste: grossiste,
        code: code,
        cmdVf: row[colCmd] === undefined ? 0 : row[colCmd],
      });
    }
  }

  return { array: array, test: test };
}






